import React from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { handleValidateCodevalue } from '../../Utility/constant';


const FolderSelectDropdown = ({
    selectedFolders,
    availableFolders,
    foldersLoading,
    onFolderChange,
    disabled,
    internationalise,
    className = "",
    sx = { width: "50%", marginBottom: 2 }
}) => {

    const handleChange = (event, newValue) => {
        // Handle "Select All" option
        const selectAllClicked = newValue.some(v => v.name === 'SELECT_ALL');
        if (selectAllClicked) {
            onFolderChange(availableFolders);
        } else {
            onFolderChange(newValue);
        }
    };

    return (
        <Autocomplete
            className={className}
            multiple
            sx={sx}
            options={[{ name: 'SELECT_ALL' }, ...availableFolders]}
            getOptionLabel={(option) =>
                option.name === 'SELECT_ALL'
                    ? handleValidateCodevalue(internationalise, 'COMMON_SELECT_ALL') || 'Select All'
                    : option.name
            }
            value={selectedFolders}
            onChange={handleChange}
            loading={foldersLoading}
            disabled={disabled}
            isOptionEqualToValue={(option, value) => option.name === value.name}
            filterSelectedOptions
            renderTags={(value, getTagProps) =>
            value.map((option, index) => {
                const tagProps = getTagProps({ index });

                const isInbox = option.name === "INBOX";

                return (
                    <Chip
                        sx = {{m: "5px 2px"}}
                        variant="outlined"
                        label={option.name}
                        size="small"
                        onDelete={!isInbox ? tagProps.onDelete : undefined}
                    />
                );
            })
        }
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    label={handleValidateCodevalue(internationalise, 'TASK_FOLDER_SELECT')}
                    placeholder={selectedFolders.length === 0
                    ? handleValidateCodevalue(internationalise, 'TASK_SELECT_FOLDERS')
                    : ''}
                />
            )}
        />
    );
};

export default FolderSelectDropdown;
